import { Palette } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const codeBlockHeaderStyle = (palette: Palette) => ({
  p: 1.2,
  cursor: "pointer",
  backgroundColor:
    palette.mode === "dark" ? palette.grey[900] : palette.background.default,
});

export const codeBlockBodyStyle = (palette: Palette) => ({
  borderTop: `1px solid ${palette.text.borderLine}`,
  backgroundColor: palette.primary.main,
  p: 1.5,
});

export const codeLineNumberStyle = (palette: Palette) => ({
  width: 18,
  flexShrink: 0,
  textAlign: "right",
  fontFamily: "ui-monospace, Menlo, monospace",
  fontSize: 12,
  lineHeight: 1.6,
  color: alpha(palette.primary.contrastText || "#fff", 0.4),
});

export const codeLineTextStyle = (palette: Palette) => ({
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  fontSize: 12,
  lineHeight: 1.6,
  color: palette.info.light,
  whiteSpace: "pre",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const codeOutputLabelStyle = (palette: Palette) => ({
  color: alpha(palette.primary.contrastText || "#fff", 0.5),
  display: "block",
  mb: 0.8,
});

export const codeOutputTextStyle = (palette: Palette, isError?: boolean) => ({
  fontFamily: "ui-monospace, Menlo, monospace",
  fontSize: 12,
  color: isError ? palette.error.light : palette.success.light,
  whiteSpace: "pre-wrap",
});
